import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Button, Heading, Text, Link, Flex } from '@pancakeswap-libs/uikit'
import QuestionHelper from 'components/QuestionHelper'
import Input from 'components/Input'
import BalanceInput from 'components/Input/BalanceInput'
import { useERC20 } from 'hooks/useContract'
import { useAllowance } from 'hooks/useAllowance'
import { useTokenApprove } from 'hooks/useApprove'
import { useTokenBalance } from 'hooks/useTokenBalance'
import { getSep20FactoryAddress } from 'utils/addressHelpers'
import useI18n from 'hooks/useI18n'

import { useFeeToken, useCreateSep20TokenInscriptions } from '../hooks/useSep20Factory'


const Row = styled.div`
  margin-top: 25px;
`;

const Label = styled(Text)`
  text-align: left;
  padding-left: 16px;
  margin-bottom: 5px;
`

const StyledEndAdornment = styled.span`
  color: ${(props) => props.theme.colors.primary};
`

const Notification = styled(Text)`
  line-height: 18px;
  padding-top: 10px;
`

interface CreateProps {
  onSuccess?: any
}

const Create: React.FC<CreateProps> = ({ onSuccess }) => {
  const TranslateString = useI18n();
    const { account } = useWallet();

    const [name, setName] = useState('')
    const handleNameChange = (e: React.FormEvent<HTMLInputElement>) => {
      setName(e.currentTarget.value); 
    }
    
    const [symbol, setSymbol] = useState('')
    const handleSymbolChange = (e: React.FormEvent<HTMLInputElement>) => {
      setSymbol(e.currentTarget.value) 
    }
        
    const [decimals, setDecimals] = useState('18')
    const handleDecimalsChange = (e: React.FormEvent<HTMLInputElement>) => {
      setDecimals(e.currentTarget.value)
    }

    const [maxSupply, setMaxSupply] = useState('')
    const handleMaxSupplyChange = (e: React.FormEvent<HTMLInputElement>) => {
      setMaxSupply(e.currentTarget.value)
    }

    const [mintAmount, setMintAmount] = useState('')
    const handleMintAmountChange = (e: React.FormEvent<HTMLInputElement>) => {
      setMintAmount(e.currentTarget.value)
    }
    
    const [mintCap, setMintCap] = useState('')
    const handleMintCapChange = (e: React.FormEvent<HTMLInputElement>) => {
      setMintCap(e.currentTarget.value)
    }
    
    const [mintFee, setMintFee] = useState('0')
    const handleMintFeeChange = (e: React.FormEvent<HTMLInputElement>) => {
      setMintFee(e.currentTarget.value)
    }

    const feeToken:any = useFeeToken();
    const feeTokenString = `${feeToken.creationFee} ${feeToken.symbol}`;
    const feeTokenBalance = useTokenBalance(feeToken.address).div(new BigNumber(10).pow(feeToken.decimals));
    const notEnoughFee = feeTokenBalance.isLessThan(feeToken.creationFee);

    const [requestedApproval, setRequestedApproval] = useState(false)
    const [approved, setApproved] = useState(0)
    const [pendingTx, setPendingTx] = useState(false)

    const tokenContract = useERC20(feeToken.address);
    const allowance = useAllowance(tokenContract, getSep20FactoryAddress(), approved);
    const onApprove = useTokenApprove(tokenContract, getSep20FactoryAddress())
    const allowed = allowance && !allowance.div(new BigNumber(10).pow(feeToken.decimals)).isLessThan(feeToken.creationFee);

    const handleApprove = useCallback(async () => {
        try {
            setRequestedApproval(true)
            const txHash = await onApprove()
            setRequestedApproval(false)
            if (txHash) {
                setApproved(approved+1);
            }
        } catch (e) {
            console.error(e)
        }
    }, [onApprove, approved])

    const onCreate = useCreateSep20TokenInscriptions();
    const handleSubmit = useCallback(async () => {
        try {
          const txHash = await onCreate(name, symbol.trim(), parseInt(decimals), new BigNumber(maxSupply), new BigNumber(mintAmount),
            mintCap || 0, new BigNumber(mintFee || 0));
          if (txHash) onSuccess();
          return txHash;
        } catch (e) {
          console.error(e)
        }

        return false;
      }, [onCreate, name, symbol, decimals, maxSupply, mintAmount, mintCap, mintFee, onSuccess])

    let invalidString = "";
    if (!name) invalidString = TranslateString(1534,"Invalid Token Name");
    else if (name.length > 40) invalidString = TranslateString(1535,"Token Name Too Long");
    else if (!symbol) invalidString = TranslateString(1536,"Invalid Token Symbol");
    else if (symbol.length > 10) invalidString = TranslateString(1537,"Token Symbol Too Long");
    else if (!decimals || !Number.isInteger(Number(decimals)) || parseInt(decimals) > 20 || parseInt(decimals) < 0 ) invalidString = TranslateString(1538,"Invalid Decimals");
    else if (!maxSupply || Number.isNaN(Number(maxSupply)) || Number(maxSupply)<=0 || new BigNumber(maxSupply).isGreaterThan(1e15) ) invalidString = TranslateString(1547,"Invalid Max Supply");
    else if (!mintAmount || Number.isNaN(Number(mintAmount)) || Number(mintAmount)<=0 
      || new BigNumber(maxSupply).isLessThan(mintAmount) || !new BigNumber(maxSupply).mod(mintAmount).isEqualTo(0) ) invalidString = TranslateString(1548,"Invalid Minting Amount");
    else if (mintCap && (!Number.isInteger(Number(mintCap)) || Number(mintCap)<0 )) invalidString = TranslateString(1549,"Invalid Minting Limit");
    else if (mintFee && (Number.isNaN(Number(mintFee)) || Number(mintFee)<0 )) invalidString = TranslateString(1550,"Invalid Minting Fee");

    const renderButton = () => {
        if (!allowed && !notEnoughFee) {
            return (
                <Button disabled={requestedApproval} onClick={handleApprove}>
                    {requestedApproval?TranslateString(330,"Approving"):TranslateString(316,"Approve")} {feeToken.symbol}
                </Button>
            )
        }
        return (
            <Button disabled={pendingTx || notEnoughFee || !!invalidString} onClick={async () => {
                setPendingTx(true)
                const txHash = await handleSubmit()
                setPendingTx(false)
              }}>
                {notEnoughFee?TranslateString(319,"Insufficient Fee"):(invalidString||TranslateString(320,"Submit"))}
            </Button>
        )
    }
    return (
        <>
            <Row>
              <Label>{TranslateString(410,'Name:')}</Label>
              <Input placeholder={TranslateString(411,'Token Name')} value={name} onChange={handleNameChange} />
            </Row>
            <Row>
              <Label>{TranslateString(412,'Symbol:')}</Label>
              <Input placeholder={TranslateString(415,"Token Symbol")} value={symbol} onChange={handleSymbolChange} />
            </Row>
            <Row>
              <Label>{TranslateString(540,"Decimals (0-20):")}</Label>
              <Input placeholder={TranslateString(416,"Token Decimals")} value={decimals} onChange={handleDecimalsChange} />
            </Row>
            <Row>
              <Label>{TranslateString(1525,"Max Supply")}{TranslateString(1108,':')}</Label>
              <Input placeholder={TranslateString(1525,"Max Supply")} value={maxSupply} onChange={handleMaxSupplyChange} />
            </Row>
            <Row>
              <Label><Flex alignItems="center" justifyContent="flex-start">
                  <div>{TranslateString(1526,"Minting Amount")}{TranslateString(1108,':')}</div>
                  <QuestionHelper text={TranslateString(1529,'The amount of token created in each minting action.')} />
              </Flex></Label>
              <Input placeholder={TranslateString(1526,"Minting Amount")} value={mintAmount} onChange={handleMintAmountChange} />
            </Row>
            <Row>
              <Label><Flex alignItems="center" justifyContent="flex-start">
                  <div>{TranslateString(1527,"Minting Limit")}{TranslateString(1108,':')}</div>
                  <QuestionHelper text={TranslateString(1530,'Optional. The maximum times an address can mint the token. If left empty it will be unlimited.')} />
              </Flex></Label>
              <Input placeholder={TranslateString(1527,"Minting Limit")} value={mintCap} onChange={handleMintCapChange} />
            </Row>
            <Row>
              <Label><Flex alignItems="center" justifyContent="flex-start">
                  <div>{TranslateString(1528,"Minting Fee")}{TranslateString(1108,':')}</div>
                  <QuestionHelper text={TranslateString(1531,'Optional. The fee (EBEN) for each minting action. 100% of the minting fee will be burned.')} />
              </Flex></Label>
              <Input placeholder={TranslateString(1528,"Minting Fee")} value={mintFee} onChange={handleMintFeeChange} endAdornment={<StyledEndAdornment>EBEN</StyledEndAdornment>} />
            </Row>
            <Row>
              <Notification>{TranslateString(315,"Fee")}: {feeTokenString}</Notification>
            </Row>
            <Row>
              {renderButton()}
            </Row>
        </>
    )
}

export default Create
 